module.exports = __webpack_public_path__ + "static/media/sticker-bc2022-view.278b4add.jpg";